module.exports = __webpack_public_path__ + "img/ava2.80b99027.png";